import * as React from 'react';
import * as uuidv4 from 'uuid/v4';

export interface IconImageColorFilterProps {
  readonly useFilter?: boolean;
  readonly filterRed?: number;
  readonly filterGreen?: number;
  readonly filterBlue?: number;
  readonly filterAlpha?: number;
}

interface IconImageProps extends IconImageColorFilterProps {
  readonly src: string;
  readonly style?: React.CSSProperties;
  readonly svgStyle?: React.CSSProperties;
}

const imageStyle: React.CSSProperties = {
  pointerEvents: 'none',
};

const IconImage: React.SFC<IconImageProps> = React.memo((props) => {
  const { src, style, svgStyle, useFilter } = props;

  const svgBaseStyle: React.CSSProperties = {
    width: '48px',
    height: '48px',
    pointerEvents: 'none',
  };

  if (useFilter !== true) {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        style={{ ...svgBaseStyle, ...svgStyle }}>
        <image
          xlinkHref={src}
          width="100%"
          height="100%"
          style={style} />
      </svg>
    );
  }

  const { filterRed, filterGreen, filterBlue, filterAlpha } = props;
  const filterID: string = uuidv4();

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      style={{ ...svgBaseStyle, ...svgStyle }}>
      <image
        xlinkHref={src}
        width="100%"
        height="100%"
        style={{ ...imageStyle, ...style, filter: `url(#${filterID})` }} />
      <defs>
        <filter id={`${filterID}`} colorInterpolationFilters="sRGB">
          <feComponentTransfer>
            <feFuncR type="linear" slope={filterRed != null ? filterRed : 1} />
            <feFuncG type="linear" slope={filterGreen != null ? filterGreen : 1} />
            <feFuncB type="linear" slope={filterBlue != null ? filterBlue : 1} />
            <feFuncA type="linear" slope={filterAlpha != null ? filterAlpha : 1} />
          </feComponentTransfer>
        </filter>
      </defs>
    </svg>
  );
});

export default IconImage;
